export const siteConfig = {
  siteName: 'Vigorbuy Spreadsheet',
  domain: 'https://vigorbuyspread.rest',
  mainSite: 'https://kaspreadsheet.com',
  mainSiteLabel: 'Vigorbuy Spreadsheet',
};

export const categories = [
  { id: 1, name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { id: 2, name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { id: 3, name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-shirt-line' },
  { id: 4, name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-honour-line' },
  { id: 5, name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line' },
  { id: 6, name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-user-3-line' },
  { id: 7, name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { id: 8, name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-checkbox-blank-line' },
  { id: 9, name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-football-line' },
  { id: 10, name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-glasses-line' },
  { id: 11, name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-briefcase-line' },
  { id: 12, name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link' },
  { id: 13, name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { id: 14, name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

export const trustItems = [
  'Updated Resources',
  'Beginner Friendly Guides',
  'Product Comparison Tables',
  'Safety Education',
  'Global Shopping Tips',
];

export const featureCards = [
  {
    icon: 'ri-search-eye-line',
    title: 'Product Discovery',
    description: 'Explore organized Vigorbuy Spreadsheet resources with categorized products, recommendations and buying tips across multiple categories.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Quality Research',
    description: 'Learn how QC photos, reviews and product information help you make smarter purchasing decisions with confidence.',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Beginner Tutorials',
    description: 'Step-by-step guides designed for users who are new to Vigorbuy Spreadsheet, making product research simple and accessible.',
  },
  {
    icon: 'ri-lock-line',
    title: 'Safety Knowledge',
    description: 'Understand risks, verification methods and safe browsing practices to protect yourself while using spreadsheet resources.',
  },
];

export const comparisonData = [
  { feature: 'Product Organization', vigorbuy: 'Excellent', traditional: 'Medium' },
  { feature: 'Price Comparison', vigorbuy: 'Easy & Fast', traditional: 'Time-Consuming' },
  { feature: 'Category Research', vigorbuy: 'Structured', traditional: 'Scattered' },
  { feature: 'QC Information', vigorbuy: 'Comprehensive', traditional: 'Limited' },
  { feature: 'Beginner Friendly', vigorbuy: 'Yes — Step by Step', traditional: 'Depends on Seller' },
];

export const howItWorksSteps = [
  {
    step: 1,
    title: 'Explore Vigorbuy Spreadsheet Resources',
    description: 'Browse organized categories and discover products, guides and comparison tables tailored to your shopping needs.',
  },
  {
    step: 2,
    title: 'Compare Information',
    description: 'Review quality indicators, pricing data and community recommendations to evaluate your options thoroughly.',
  },
  {
    step: 3,
    title: 'Make Smarter Decisions',
    description: 'Use comprehensive research data before purchasing — reduce returns, save money and shop with confidence.',
  },
];

export const faqItems = [
  {
    question: 'What is Vigorbuy Spreadsheet?',
    answer: 'Vigorbuy Spreadsheet is a structured resource hub that helps users discover, organize and compare product information efficiently across multiple shopping categories including shoes, clothing, accessories and more.',
  },
  {
    question: 'Is Vigorbuy Spreadsheet free to use?',
    answer: 'Many Vigorbuy Spreadsheet resources are publicly accessible, offering free product guides and comparison tools. Always verify the source of any spreadsheet you download and ensure you are using trusted, updated versions.',
  },
  {
    question: 'How can beginners start using Vigorbuy Spreadsheet?',
    answer: 'Start with our beginner-friendly guides, explore product categories one at a time, compare different items using the built-in comparison tools, and follow our safety recommendations to build your shopping knowledge step by step.',
  },
];

export const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Shopping Guide', href: '/article/vigorbuy-spreadsheet-beginner-guide' },
  { label: 'Categories', href: '#categories' },
  { label: 'Safety', href: '#safety' },
  { label: 'Articles', href: '#articles' },
];